<template>

  <div class="post">

    <transition name="slide-fade-up">
    <Footer/>
    </transition>
  </div>
</template>

<script>
  import Footer from '../../components/Footer/Footer.vue';
  export default {
    components: {
      Footer,
    },
    mounted: function () {
      this.$store.commit('setTitle', 'Page not found');
      const slide = {
        id: 'notfound',
        img: null,
        title: 'Page not found',
      }
      this.$store.commit('setHero', {
        slides: [slide],
        showSlideShow: false,
        hideTitle: false,
      });
    },

    methods: {
    },

    data() {
      return {
      };
    },
  };
</script>

<style lang="scss" >
</style>
